module.exports = __webpack_public_path__ + "img/1059778847.db73fcce.jpg";